<template>
  <div class="w-100">
    <div class="p-20" style="background:rgba(229,246,247,1);">
      <el-row :gutter="10">
        <el-form :inline="true" class="demo-form-inline">
          <el-col>
            <el-form-item class="m-b-0">
              <el-link type="success" class="m-r-15" @click="toshijian('1')">今日</el-link>
              <el-link type="success" class="m-r-15" @click="toshijian('4')">本月</el-link>
              <el-link type="primary" class="m-r-15" @click="toshijian('2')">上日</el-link>
              <el-link type="primary" class="m-r-25" @click="toshijian('3')">下日</el-link>
            </el-form-item>
            <el-form-item label="日期" class="m-b-0">
              <el-date-picker
                v-model="search.time[0]"
                type="date"
                placeholder="开始日期"
                style="width: 135px;"
              ></el-date-picker>至
              <el-date-picker
                v-model="search.time[1]"
                type="date"
                placeholder="结束日期"
                style="width: 135px;"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="门店" class="m-b-0">
              <el-select v-model="xlgid" placeholder="请选择" @change="xuanzhe">
                <el-option
                  v-for="item in xlclist"
                  :key="item.id"
                  :label="item.garageName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提成用户" class="m-b-0">
              <el-input v-model="search.name" placeholder style="width:100px;"></el-input>
            </el-form-item>
            <el-form-item label="链接名称" class="m-b-0">
              <el-input v-model="urlName" placeholder style="width:150px;"></el-input>
            </el-form-item>
            <el-form-item label="服务模块" class="m-b-0">
              <el-select
                v-model="model"
                placeholder="全部"
                filterable
                @change="ChangeCustomerName"
                style="width: 130px;"
              >
                <el-option
                  v-for="(item,idx) in result"
                  :key="idx"
                  :label="item.realName"
                  :value="item.realName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-button type="success" icon="el-icon-search" @click="chazhao">查找</el-button>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <el-table :data="tableData" :max-height="maxHeight" style="width: 100%" class="orderTable">
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column prop="garageName" label="门店名称"></el-table-column>
      <el-table-column prop="shareName" label="链接名称" width="140"></el-table-column>
      <el-table-column prop="belongModel" label="所属模块"></el-table-column>
      <el-table-column prop label="售价">
        <template slot-scope="scope">{{scope.row.achievement}}</template>
      </el-table-column>
      <el-table-column prop label="购买客户">
        <template slot-scope="scope">{{scope.row.buyName}}</template>
      </el-table-column>
      <el-table-column prop="settlementDate" label="购买时间"></el-table-column>
      <el-table-column prop="commissionName" label="提成用户"></el-table-column>
      <el-table-column prop label="提成比例">
        <template slot-scope="scope">{{scope.row.urlRate}}%</template>
      </el-table-column>
      <el-table-column prop label="提成金额">
        <template slot-scope="scope">{{scope.row.redAmount}}</template>
      </el-table-column>

      <el-table-column prop="mangeAmont" label="佣金"></el-table-column>
      <el-table-column prop="balance" label="余额"></el-table-column>
    </el-table>

    <div class="p-tb-10 text-center">
      <el-pagination
        :hide-on-single-page="pageLength === 0"
        background
        layout="prev, pager, next"
        :page-size="size"
        @current-change="nextPage"
        :total="pageLength"
      ></el-pagination>
    </div>
    <div class="dibu">
      <span>
        平台佣金合计:
        <span class="jine">{{mangeAmount}}</span>
      </span>
      <span style=" margin-left: 45px;">
        提成金额合计:
        <span class="jine">{{redAmount}}</span>
      </span>
      <span style=" margin-left: 45px;">
        门店余额:
        <span class="jine">{{balance}}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { report, queryGarageInfo } from "../../request/api.js";
import moment from "moment";
export default {
  name: "order",
  data() {
    return {
      seriesOrBrand: "",
      letterIndex: "",
      tableData: [],
      tableData2: {},
      orderNavActive: 0,
      dialogVisibleB: false,
      maxHeight: undefined,
      urlName: "",
      model: "全部",
      balance: "",
      mangeAmount: "",
      redAmount: "",
      pageLength: null,
      page: 0,
      size: 10,
      search: {
        time: [
          moment(new Date()).format("YYYY-MM-01"),
          moment(new Date()).format("YYYY-MM-DD")
        ]
      },

      xlgid: 0,
      pageLength: null,
      size: 10,
      page: 0,
      dialogVisible: false,
      src: "",
      carVisible: false,
      addCarForm: {},
      xlclist: [],
      result: [
        { realName: "全部" },
        { realName: "秒杀产品" },
        { realName: "精品车品" },
        { realName: "快修快保" },
        { realName: "美容洗车" },
        { realName: "喷漆" },
        { realName: "会员卡" },
        { realName: "套餐卡" }
      ],
      carInfo: {
        type: "1"
      },
      brandList: [],
      modelList: [],
      searchInfo: {},
      type: 5
    };
  },
  created() {
    this.xiulichang();
    this.init();
  },
  mounted() {
    this.maxHeight = $(".tabBox").height() - 230;
  },
  methods: {
    init() {
      const data = {
        model: this.model != "全部" ? this.model : null,
        name: this.search.name,
        urlName: this.urlName,
        endTime: this.search.time[1],
        startTime: this.search.time[0],
        gid: this.xlgid,
        page: this.page,
        size: this.size,
        type: this.type
      };
      report(data).then(res => {
        this.tableData = res.data.data.page.content;
        this.pageLength = res.data.data.page.totalElements;
        this.tableData.forEach((item, index) => {
          item.index = index + 1 + this.page * 10;
        });
        this.balance = res.data.data.balance;
        this.mangeAmount = res.data.data.mangeAmount;
        this.redAmount = res.data.data.redAmount;
      });
    },

    xiulichang() {
      queryGarageInfo().then(res => {
        this.xlclist = res.data.data;
        var quan = {
          id: 0,
          garageName: "全部"
        };
        this.xlclist.unshift(quan);
      });
    },
    chazhao() {
      // console.log(this.search.time[1]);
      if (
        this.search.time[1] != undefined &&
        this.search.time[1] != undefined
      ) {
        this.search.time.forEach((i, index) => {
          this.search.time[index] = moment(i).format("YYYY-MM-DD");
        });
        this.type = 5;
      }
      this.init();
    },
    timestampToTime(row, column) {
      var date = new Date(row.createTime * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
    toshijian(val) {
      // this.search.time = [];
      this.type = val;
      this.init();
    },
    xuanzhe(e) {
      console.log(e);
      this.xlgid = e;
      this.init();
    },
    ChangeCustomerName(e) {
      this.page = 0;
      this.init();
    },
    nextPage(page) {
      this.page = page - 1;
      this.init();
      return;
    }
  }
};
</script>
<style scoped>
.orderUl li {
  float: left;
  padding: 4px 18px;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
  transition: 0.5s;
  font-size: 16px;
}
.jine {
  color: red;
  font-weight: 600;
}
.dibu {
  font-size: 15px;
  position: fixed;
  line-height: 50px;
  margin-left: 140px;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 99;
}
.orderUl li:hover {
  background: rgba(0, 0, 0, 0.1);
  transition: 0.5s;
}

.orderUl li.active {
  background: #3ac29f;
  color: #fff;
}
.letter a {
  color: #3b5998;
  border: 1px solid #eee;
  margin: 3px;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-weight: bold;
  display: inline-block;
}
.letter a:hover,
.letter a.active {
  background: #3b5998;
  color: #fff;
}
.overlay {
  position: absolute;
  z-index: 2000;
  background-color: hsla(0, 0%, 100%, 0.9);
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: opacity 0.3s;
}
.dialog-footer {
  margin-bottom: 20px;
  overflow: hidden;
}
</style>
<style >
</style>


// WEBPACK FOOTER //
// src/page/home/order_deduct.vue